<template>
  <div class="frontindex">
    <el-container class="content_wrapper">
      <el-header class="content_header" style="position: fixed;z-index: 99;width: 100%;">
      	<div class="navcontent">
      		<div class="headlayout clear">
	          <div class="logo icon-my-logo fl" @click="clickLogin"></div>
            <!--<div class="login-register">-->
              <!--<span class="front_login fr" @click="register()" title="注册" v-if="!islogin">注册</span>-->
              <!--<span class="front_login fr login-border" @click="loginFront()" title="登录" v-if="!islogin">登录</span>-->
              <!--<span class="front_login fr" style="width: 45px;color: rgb(16, 142, 233);" @click="exitFront()" v-if="islogin">&nbsp;退出</span>-->
              <!--<span class="front_login fr" style="width: 95px;" @click="personalInfo()" v-if="islogin">{{this.$store.getters.userinfo.mobile}}，</span>-->
            <!--</div>-->
		        <el-menu
		          router
		          :default-active="pagedefault"
		          class="front-menu fr"
		          mode="horizontal"
		          text-color="#fff"
		          active-text-color="#108EE9" style="margin-right: 38px;">
		          <el-menu-item index="/">首页</el-menu-item>
		          <el-menu-item index="/front/document/index" style="margin-left: 38px;">开发文档</el-menu-item>
		          <el-menu-item index="/front/example/code" style="margin-left: 38px;">示例代码</el-menu-item>
		          <el-menu-item index="/front/business/cooperation" style="margin-left: 38px;">商务合作</el-menu-item>
              <el-menu-item index="/front/business/cooperation" style="margin-left: 38px;"></el-menu-item>
              <el-submenu index="/front/developer" popper-class="login-child-menu">
                <template slot="title"><div class="iconfont icongerenzhongxin"></div></template>
                <el-menu-item  v-if="!islogin" index="/front/developer">登录</el-menu-item>
                <el-menu-item  v-if="!islogin" index="/front/devregiser">注册</el-menu-item>
                <el-menu-item  v-if="islogin" index="/front/developer">{{this.$store.getters.userinfo.mobile}}</el-menu-item>
                <el-menu-item  v-if="islogin" @click="exitFront()">退出</el-menu-item>
              </el-submenu>
	        </el-menu>
        </div>
      	</div>
      
      </el-header>
      <el-main style="margin-top: 60px;">
        <router-view />
      </el-main>
      <div id="toTop" class="toTop" v-show="isShow" @click="toTop()"></div>
      <el-footer class="content_footer">
        <div style="margin-top: 22px;">
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank" class="underline"
            style="color: #fff"
          >
          赣ICP备2023007586号-4
          </a>
        </div>
        <div style="margin-top: 10px;">江西三端科技有限公司 {{showMsg}}</div>
      </el-footer>
    </el-container>
  </div>
</template>
<script type="text/babel">
import {mapGetters, mapMutations} from 'vuex'
export default {
  data: function () {
    return {
      pagedefault: '/',
      islogin: false,
      showMsg: 'Copyright ©1996-' + new Date().getFullYear() + ' All Rights Reserved',
      isShow: false
    }
  },
  computed: {
    ...mapGetters(['userinfo'])
  },
  watch: {
    '$route.name'(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (['frontlogin', 'developer'].includes(newValue)) {
          this.pagedefault = '/'
          this.$nextTick(() => {
            this.pagedefault = '/front/developer'
          })
        }
      }
    },
    userinfo (newVal, oldVal) {
      this.islogin = !!(this.userinfo && this.userinfo.clientId)
    }
  },
  components: {
  },
  name: 'frontIndex',
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.islogin = !!(this.userinfo && this.userinfo.clientId)
    if (this.$route.meta && this.$route.meta.index) {
      // 实现路由切换
      this.pagedefault = this.$route.meta.index
      if (this.$route.fullPath === '/front/devDocument/agreement') {
        this.$router.push({name: 'devDocumentAgreement'})
        return
      }
      if (this.$route.path !== this.$route.meta.index) {
        this.$router.push({path: this.$route.meta.index})
      }
      return
    }
    this.$router.push({name: 'fronthome'})
  },
  updated () {
  },
  destroyed () {
		  window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    clickLogin () {
      this.pagedefault = ''
      this.$router.push({name: 'fronthome'})
      this.$nextTick(() => {
        this.pagedefault = '/'
      })
    },
    // loginFront () {
    //   this.pagedefault = '/'
    //   this.$router.push({name: 'frontlogin'})
    //   this.$nextTick(() => {
    //     this.pagedefault = '/front/developer'
    //   })
    // },
    register () {
      this.$router.push({name: 'devregiser'})
    },
    exitFront () {
      this.$cookie.delete('token')
      // 清空Vuex
      this.clearUserInfo()
      this.$router.push({name: 'frontlogin'})
      this.pagedefault = '/'
      this.$nextTick(() => {
        this.pagedefault = '/front/developer'
      })
    },
    // personalInfo () {
    //   this.pagedefault = '/'
    //   this.$router.push({name: 'developerdetail'})
    //   this.$nextTick(() => {
    //     this.pagedefault = '/front/developer'
    //   })
    // },
    // 屏幕滚动
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let webpageVisibleW = document.documentElement.clientWidth || document.body.clientWidth
      if (webpageVisibleW < 1200) {
        this.isShow = false
      } else {
        if (scrollTop > 500) {
          this.isShow = true
        } else {
          this.isShow = false
        }
      }
    },
    toTop () {
	      let distanceY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
	      let i = 0
	      this.interval = setInterval(() => {
		      if (distanceY - 60 > 0) {
		        distanceY -= 60
		        window.scrollTo(0, distanceY)
		      } else {
		        window.scrollTo(0, 0)
		        clearInterval(this.interval)
		      }
	      }, 10)
    },
    ...mapMutations({
      clearUserInfo: 'clearUserInfo'
    })
  }
}
</script>
<style scoped>

	.fl{
		float: left;
	}
	.fr{
		float: right;
	}
	.clear:after{
	    content: "";
	    display: block;
	    height: 0;
	    clear: both;
	    visibility: hidden;
	}
	.frontindex{
	  width: 100%;
	  min-height: 100vh;
	}
	.frontindex .content_wrapper{
	  width: 100%;
	  min-height: 100vh;
    background-color: #f7f7f7;
	}
	.frontindex .front-menu .el-menu-item{
    font-size: 16px;
  }
	.frontindex .headlayout{
	  height: 60px;
	  background-color:#232940;
	}
	.frontindex .headlayout .front-menu{
	  display: inline-block;
	  background-color: transparent;
	}
	.frontindex .headlayout .logo{
	  width: 178px;
	  height: 30px;
	  margin-top: 15px;
	  display: block;
    margin-left: 10px;
	}
  .frontindex .headlayout .login-register{
    right: 20px;
    position: absolute;
  }
	.frontindex .headlayout .front_login{
	  width: 36px;
	  height: 15px;
    line-height: 15px;
	  display: block;
	  cursor: pointer;
	  margin-top: 23px;
    color: #ffffff;
	}
  .frontindex .headlayout .login-border{
    border-right: 2px solid #ffffff;
    margin-right: 6px;
  }
	.navcontent{
		width: 1200px;
		margin: 0 auto;
	}
	.content_header{
		background: #232940;
	}
	.frontindex .el-menu-item{
  	text-align: center;
  	padding: 0;
  }
	.frontindex .el-menu-item:first-child.is-active{
  	color: white !important;
    border-bottom-color: black !important;
  }
  .frontindex .toTop{
  	position: fixed;
  	bottom: 122px;
  	right: 139px;
  	background: rgba(0,0,0,0.16) url(../../assets/images/front/totop.png) center center no-repeat;
  	width: 60px;
  	height: 60px;
  	cursor: pointer;
  	border-radius: 50%;
  	z-index: 11;
  }
  .frontindex .toTop:hover{
  	background: rgba(0,0,0,0.2) url(../../assets/images/front/totop.png) center center no-repeat;
  }
</style>
<style type="text/css">
  .frontindex .el-header{
    padding: 0px;
  }
  .frontindex .el-main{
    padding: 0px;
    height: 100%;
    overflow: hidden;
  }
  .frontindex  .headlayout  .el-dropdown-menu__item--divided:before,
  .frontindex  .headlayout  .el-menu,
  .frontindex  .headlayout  .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
  .frontindex  .headlayout  .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
  .frontindex  .headlayout  .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
    background-color: transparent;
  }
 .frontindex .front-menu.el-menu--horizontal>.el-menu-item.is-active,
 .frontindex .front-menu.el-menu--horizontal>.el-menu-item:hover{
    /*border-bottom: 3px solid #108EE9;
    background-color: transparent;
    transition: all 1s;*/
  }
  .frontindex .front-menu.el-menu--horizontal>.el-menu-item:after {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    right: 50%;
    bottom: 0px;
    height: 3px;
    opacity: 0;
    background-color: #108EE9;
    -webkit-transition: all .5s;
    -o-transition: all .5s;
    -ms-transition: all .5s;
    transition: all .5s;
	}
	.frontindex .front-menu.el-menu--horizontal>.el-menu-item.is-active:after{
    left: 1%;
    right: 1%;
    opacity: 1;
    -webkit-transition: all .5s;
    -o-transition: all .5s;
    -ms-transition: all .5s;
    transition: all .5s;
	}
	.frontindex .front-menu.el-menu--horizontal>.el-menu-item.is-active:first-child:after{
		opacity: 0;
	}
  .frontindex .content_footer{
    height: 80px!important;
    text-align: center;
    background-color: #232940;
    color: #ffffff;
    font-size:12px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color:rgba(255,255,255,1);
  }
  .frontindex .headlayout .el-menu.el-menu--horizontal{
    border: none;
  }
  .frontindex .el-menu--horizontal>.el-menu-item.is-active{
  	border: none !important;
  }

  .login-child-menu ul{
    background-color: #232940;
  }

  .login-child-menu .el-menu{
    min-width: 0px;
  }

  .login-child-menu .el-menu .el-menu-item{
    background-color: #232940;
    padding: 0px 20px;
  }

  .frontindex .el-submenu__title .el-submenu__icon-arrow{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/index.vue